import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const WELCOME_BANNER_DISMISSED_KEY = 'chowmedown_welcome_dismissed';

const WelcomeBanner: React.FC = () => {
  const { user } = useAuth();
  
  // Initialize state based on localStorage synchronously to avoid flash
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem(WELCOME_BANNER_DISMISSED_KEY) === 'true';
  });

  const handleDismiss = () => {
    localStorage.setItem(WELCOME_BANNER_DISMISSED_KEY, 'true');
    setDismissed(true);
  };

  // Only show banner if user is logged in and hasn't dismissed it
  if (!user || dismissed) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%)',
      borderBottom: '2px solid #feceacff',
      padding: '16px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: '1.5rem', flexShrink: 0 }}>🐾</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <strong style={{ color: '#9a3412', fontSize: '1.1rem', display: 'block', marginBottom: '4px' }}>
            Welcome!
          </strong>
          <p style={{ margin: 0, fontSize: '0.95rem', color: '#7c2d12' }}>
            Start by <strong style={{ color: '#7c2d12' }}>picking a recipe</strong> or{' '}
            <Link to="/recipe-builder" style={{ color: '#ea580c', textDecoration: 'underline', fontWeight: 600 }}>
              calculating portions
            </Link>
            {' '}tailored to your dog.
          </p>
        </div>
      </div>
      <button
        onClick={handleDismiss}
        style={{
          background: 'transparent',
          border: 'none',
          fontSize: '1.8rem',
          cursor: 'pointer',
          padding: '4px 8px',
          color: '#9a3412',
          lineHeight: 1,
          flexShrink: 0,
          minWidth: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '120px'
        }}
        aria-label="Dismiss banner"
      >
        ×
      </button>
    </div>
  );
};

export default WelcomeBanner;
